import { useMyProfile } from '../my-profile';
import React from 'react';
import { getCommonProductField, getDeepList } from './chatbotContractType';
import { useLocation } from 'react-router-dom';
import { registrationPagePath } from '../navigation/paths';
import { useContracts } from 'components/contracts';
import { currentBrand } from 'config';
import { Chatbot } from '@cp-shared-19/frontend-ui';

export const ChatbotWrapper: React.FC = () => {
    const location = useLocation();

    const isRegistrationPage = location.pathname === registrationPagePath();

    const { data: contracts, hasReceivedResponse: hasReceivedContracts } = useContracts();

    const { data: myProfile, hasReceivedResponse: hasReceivedProfile } = useMyProfile();

    const productType: string = hasReceivedContracts ? getCommonProductField('productType', contracts) : 'None';
    const productFamily: string = hasReceivedContracts ? getCommonProductField('productFamily', contracts) : 'None';
    const productTypeFR: string = hasReceivedContracts ? getCommonProductField('productTypeFR', contracts) : 'None';
    const contractNumber: string = hasReceivedContracts ? getCommonProductField('contractNumber', contracts) : 'None';
    const deepList: string = hasReceivedContracts ? getDeepList(contracts) : '';

    const buildConfigContext = () => {
        if (!hasReceivedProfile || !hasReceivedContracts) {
            return;
        }
        if (myProfile && contracts) {
            return {
                'global.brand': currentBrand,
                'user.firstName': myProfile?.identification?.data?.name,
                'user.lastName': myProfile?.identification?.data?.surname,
                'user.phone': myProfile?.contactDetails?.mobilePhone,
                'user.email': myProfile?.contactDetails?.email,
                'global.customerNumber': myProfile?.identification?.data?.customerNumber,
                'global.customerType': myProfile?.identification?.customerType,
                'global.productType': productType,
                'global.productFamily': productFamily,
                'global.productTypeFR': productTypeFR,
                'global.contractNumber': contractNumber,
                'global.deeplist': deepList,
            };
        }

        if (isRegistrationPage) {
            return {
                'global.brand': currentBrand,
                'user.firstName': 'KYC',
                'user.lastName': 'KYC',
                'user.phone': 'KYC',
                'user.email': 'KYC',
                'global.customerNumber': 'KYC',
                'global.customerType': 'KYC',
                'global.productType': 'KYC',
                'global.productFamily': 'KYC',
                'global.productTypeFR': 'KYC',
                'global.contractNumber': 'KYC',
                'global.deeplist': 'KYC',
            };
        }
    };

    const context = buildConfigContext();

    if (!context) {
        return <></>;
    }

    const chatbotApiKey = isRegistrationPage
        ? process.env.REACT_APP_CHATBOT_REGISTRATION_API_KEY
        : process.env.REACT_APP_CHATBOT_API_KEY;

    return (
        <Chatbot
            oidc
            context={context}
            mercuryCssUrl={process.env.REACT_APP_CHATBOT_CSS_URL || ''}
            mercuryApiKey={chatbotApiKey || ''}
        />
    );
};
